import {
	Component,
	ElementRef,
	Inject,
	Input,
	OnInit,
	Renderer2,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { MediaObserver } from '@angular/flex-layout';
import {
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import {
	MatSlideToggleChange,
	MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { MediaService } from 'src/app/pages/fundraiser/services/media.service';
import { EmbedPreview } from 'src/app/pages/fundraiser/models/embedPreview';
import { CustomDomainService } from 'src/app/global/services/custom-domain.service';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgFor, NgStyle, NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

export type widgetType =
	| 'donation-widget'
	| 'show-with-image'
	| 'donation-form+image'
	| 'donation-form+widget';
/** *Script Plugin Data Service */
export interface ScriptPluginData {
	div_id: string;
	div_class: string;
	div_value: widgetType;
	data_slug: string;
	data_lang: string;
	data_box_shadow: string;
	data_primary_color: string;
	data_secondary_color: string;
	data_font_family: string;
	data_button_radius: string;
	data_card: string;
}

@Component({
	selector: 'app-embed',
	templateUrl: './embed.component.html',
	styleUrls: ['./embed.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		FlexModule,
		NgClass,
		ExtendedModule,
		MatButtonModule,
		MatTooltipModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatSlideToggleModule,
		MatExpansionModule,
		MatCardModule,
		MatButtonToggleModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		NgFor,
		MatOptionModule,
		NgStyle,
		NgIf,
		TextFieldModule,
		ClipboardModule,
	],
})
export class EmbedComponent implements OnInit {
	@Input() slug!: string;
	@Input() selectedFundraiser!: any;
	@Input() currentFundraiserData: any = {};
	@Input() amountProgressData!: any;
	@Input() profileResponse!: any;
	@ViewChild('embedView', { static: true }) embedView!: ElementRef;

	pluginData!: ScriptPluginData;
	pluginForm!: UntypedFormGroup;

	matTooltip = $localize`:@@share_fundraiser_tooltip_copy_code: Copy the code`;
	embedHTML: string = '';
	previewSwitchCase: string = 'donation-widget';
	sucessUrlPlaceholder = $localize`:@@embed_successUrl_placeholder:Success Url`;
	failUrlPlaceholder = $localize`:@@embed_failUrl_placeholder:Fail Url`;
	oneTimeLabel = $localize`:@@embed_oneTimeLabel:One Time`;
	monthlyLabel = $localize`:@@embed_monthlyLabel:Monthly`;
	yearlyLabel = $localize`:@@embed_yearlyLabel:Yearly`;
	currency_symbol: string = '';
	fundraiserBackgroundImage: string = '';
	fundraiserBackgroundVideo: string = '';
	video: string = '';
	youtubeThumbnail: any;
	videoPath!: any;
	onetime_first: string = '';
	onetime_second: string = '';
	onetime_third: string = '';
	onetime_forth: string = '';
	monthly_first: string = '';
	monthly_second: string = '';
	monthly_third: string = '';
	monthly_forth: string = '';
	yearly_first: string = '';
	yearly_second: string = '';
	yearly_third: string = '';
	yearly_forth: string = '';
	shareLink: string = '';
	previewBoxShadowNumber: number = 1;
	currentPrimaryColor: string = '#32BF55'; // Default value
	currentSecondaryColor: string = '#363396';
	currentButtonRadius: any = 4;
	widgetFontName: string = 'Roboto';

	@Input() showDonationFormOnlyChecked: boolean = false;
	@Input() showDonateCard: boolean = true;
	embedPreviewData: EmbedPreview | undefined;
	fontList: string[] = [
		'Roboto',
		'Raleway',
		'Amatic SC',
		'Caveat',
		'Comfortaa',
		'EB Garamond',
		'Lobster',
		'Lora',
		'Merriweather',
		'Montserrat',
		'Nunito',
		'Oswald',
		'Pacifico',
		'Playfair Display',
		'Spectral',
		'Open Sans',
		'Lato',
		'Yatra One',
		'Arvo',
		'Ubuntu',
		'PT Serif',
		'Slabo 13px',
		'Source Sans Pro',
		'PT Sans',
		'Noto Serif',
		'Nunito Sans',
		'Concert One',
		'Prompt',
		'Work Sans',
	];
	constructor(
		public router: Router,
		public clipboard: Clipboard,
		private _renderer: Renderer2,
		private _formBuilder: UntypedFormBuilder,
		public media: MediaObserver,
		public _accountService: AccountService,
		private _notificationService: NotificationService,
		public _mediaService: MediaService,
		@Inject(MAT_DIALOG_DATA) public data: { fundraiser: any },
		public dialogRef: MatDialogRef<EmbedComponent>,
		public customDomainService: CustomDomainService,
		public fundraiserService: FundraiserService
	) {
		this.pluginForm = this._formBuilder.group({
			hideWidgetCard: [false],
			showImageCheckbox: [false, { disabled: false }],
			addFormCheckbox: [false, { disabled: false }],
			boxShadowNumber: [this.previewBoxShadowNumber],
			currentPrimaryColor: [this.currentPrimaryColor],
			currentSecondaryColor: [this.currentSecondaryColor],
			widgetFontName: [this.widgetFontName],
			currentButtonRadius: [
				this.currentButtonRadius,
				[Validators.min(0), Validators.max(30)],
			],
		});
	}

	ngOnInit(): void {
		this.initializeFundraiserData();
		this.initializeBackgroundMedia();
		this.initializePluginForm();
		this.subscribeToFormChanges();
		this.initializeShareLink();
		this.setProfileResponseValues();
		this.subscribeToProfileResponseChanges();
	}

	/**
	 * Initialize fundraiser data
	 */
	private initializeFundraiserData(): void {
		this.currency_symbol = this.data?.fundraiser?.currency_symbol;
		this.onetime_first =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_first;
		this.onetime_second =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_second;
		this.onetime_third =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_third;
		this.onetime_forth =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_forth;
		this.monthly_first =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_first;
		this.monthly_second =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_second;
		this.monthly_third =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_third;
		this.monthly_forth =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_forth;
		this.yearly_first =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_first;
		this.yearly_second =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_second;
		this.yearly_third =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_third;
		this.yearly_forth =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_forth;
	}

	/**
	 * Initialize background media
	 */
	private initializeBackgroundMedia(): void {
		if (
			(this.data?.fundraiser?.background?.image != '' &&
				this.data?.fundraiser?.background?.video != '') ||
			(this.data?.fundraiser?.background?.image == '' &&
				this.data?.fundraiser?.background?.video != '') ||
			(this.data?.fundraiser?.background?.image != '' &&
				this.data?.fundraiser?.background?.video == '')
		) {
			this.fundraiserBackgroundImage = this.data?.fundraiser?.background?.image;
			this.fundraiserBackgroundVideo = this.data?.fundraiser?.background?.video;
		} else {
			this.fundraiserBackgroundImage =
				this.data?.fundraiser?.parent?.background?.image;
			this.fundraiserBackgroundVideo =
				this.data?.fundraiser?.parent?.background?.video;
		}
		const url: any = this.fundraiserBackgroundVideo;
		this.youtubeThumbnail = this.checkVideoUrl(url);
		this.videoPath = url;
	}

	/**
	 * Initialize plugin form
	 */
	private initializePluginForm(): void {
		let rawFormValue = this.pluginForm.getRawValue();
		let embedData = this.createEmbedData(rawFormValue);
		this.embedHTML = this.getEmbedHTML(embedData);
		/** *set embed Html in Textarea */
		// this.embedView.nativeElement.innerText = this.embedHTML;
		this.previewSwitchCase = this.getPreviewCase();
	}

	/**
	 * Subscribe to form changes
	 */
	private subscribeToFormChanges(): void {
		this.pluginForm.valueChanges.subscribe(() => {
			if (this.pluginForm.valid) {
				let rawFormValue = this.pluginForm.getRawValue();
				let embedData = this.createEmbedData(rawFormValue);
				this.embedHTML = this.getEmbedHTML(embedData);
				/** *set embed Html in Textarea */
				//this.embedView.nativeElement.innerText = this.embedHTML;
				this.previewSwitchCase = this.getPreviewCase();
			}
		});
	}

	/**
	 * Initialize share link
	 */
	private initializeShareLink(): void {
		this.customDomainService.isCustomDomain.subscribe((response) => {
			if (response) {
				this.shareLink = window.location.href;
			} else {
				const splitted = this.router.url.split('/');
				const locale = this._accountService.getLocaleId();
				const isDefaultLocale = locale === 'en';

				this.shareLink = isDefaultLocale
					? `${environment.homeUrl}/${splitted[1]}/${splitted[2]}`
					: `${environment.homeUrl}/${locale}/${splitted[1]}/${splitted[2]}`;
			}
		});
	}

	/**
	 * Set profile response values
	 */
	private setProfileResponseValues(): void {
		this.pluginForm
			.get('currentPrimaryColor')
			?.setValue(this.profileResponse.primary_color);
		this.pluginForm
			.get('currentSecondaryColor')
			?.setValue(this.profileResponse.secondary_color);
		this.pluginForm.get('widgetFontName')?.setValue(this.profileResponse.fonts);
		this.pluginForm
			.get('currentButtonRadius')
			?.setValue(this.profileResponse.button_radius);
		this.pluginForm
			.get('boxShadowNumber')
			?.setValue(Number(this.profileResponse.card_shadow));
	}

	/**
	 * Subscribe to profile response changes
	 */
	private subscribeToProfileResponseChanges(): void {
		this.pluginForm
			.get('currentPrimaryColor')
			?.valueChanges.subscribe((value) => {
				this.updateEmbedPreview();
			});

		this.pluginForm
			.get('currentSecondaryColor')
			?.valueChanges.subscribe((value) => {
				this.updateEmbedPreview();
			});

		this.pluginForm.get('widgetFontName')?.valueChanges.subscribe((value) => {
			this.updateEmbedPreview();
		});

		this.pluginForm
			.get('currentButtonRadius')
			?.valueChanges.subscribe((value) => {
				this.updateEmbedPreview();
			});

		this.pluginForm.get('boxShadowNumber')?.valueChanges.subscribe((value) => {
			this.updateBoxShadow();
		});
	}

	truncateText(text: string, maxLength: number) {
		if (this.media.isActive('xs')) {
			maxLength = 35;
			return text.slice(0, maxLength) + '...';
		} else {
			return text;
		}
	}

	copyLink() {
		this.clipboard.copy(this.shareLink);
		this._notificationService.openNotification(
			$localize`:@@share_fundraiser_link:The Link is successfully copied`,
			'OK',
			'success'
		);
	}

	/** *Disable checkbox if hide card is true */
	setWidgetCheckbox(event: MatSlideToggleChange) {
		if (event.checked) {
			this.pluginForm
				.get('showImageCheckbox')
				?.disable({ onlySelf: true, emitEvent: false });
			this.pluginForm
				.get('addFormCheckbox')
				?.disable({ onlySelf: true, emitEvent: false });
		} else {
			this.pluginForm
				.get('showImageCheckbox')
				?.enable({ onlySelf: true, emitEvent: false });
			this.pluginForm
				.get('addFormCheckbox')
				?.enable({ onlySelf: true, emitEvent: false });
		}
	}

	/** *Create Embed Data */
	createEmbedData(formData: any): ScriptPluginData {
		return {
			div_id: this.slug,
			div_class: 'share-widget',
			div_value: this.getWidgetType(formData),
			data_slug: this.slug,
			data_lang: this._accountService.getLocaleId() || 'nl',
			data_box_shadow: this.pluginForm.get('boxShadowNumber')?.value,
			data_primary_color: this.pluginForm.get('currentPrimaryColor')?.value,
			data_secondary_color: this.pluginForm.get('currentSecondaryColor')?.value,
			data_font_family: this.pluginForm.get('widgetFontName')?.value,
			data_button_radius: this.pluginForm.get('currentButtonRadius')?.value,
			data_card: formData?.hideWidgetCard ? 'hide' : 'show',
		};
	}

	/** *Get Widget Type */
	getWidgetType(formData: any): widgetType {
		if (formData?.hideWidgetCard) return 'donation-widget';

		if (formData?.addFormCheckbox) {
			if (formData?.showImageCheckbox) return 'donation-form+image';
			else return 'donation-form+widget';
		}
		if (formData?.showImageCheckbox) return 'show-with-image';

		return 'donation-widget';
	}

	/** *Get Preview Case */
	getPreviewCase() {
		let rawFormValue = this.pluginForm.getRawValue();
		let widgetType = this.getWidgetType(rawFormValue);
		if (widgetType === 'donation-widget' && rawFormValue?.hideWidgetCard) {
			this._accountService.setWidgetCheckbox('donation-button');
			return 'donation-button';
		}
		this._accountService.setWidgetCheckbox(widgetType);
		return widgetType;
	}

	getEmbedHTML(data: ScriptPluginData): string {
		/** *static data */
		let script_url, css_url;

		if (environment.production == true) {
			script_url = 'https://plugin.whydonate.com/wp_styling.js';
			css_url = 'https://plugin.whydonate.com/wdplugin-style.css';
		} else {
			script_url = 'https://plugin.whydonate.com/wp_styling_development.js';
			css_url = 'https://plugin.whydonate.com/wdplugin-style-development.css';

			// this.cssUrl =
			// 	'https://plugin.whydonate.com/wdplugin-style-development.css';
		}

		let div = this._renderer.createElement('div');
		let wrapperDiv = this._renderer.createElement('div');

		// Create and set up the CSS link element
		let link = this._renderer.createElement('link');
		this._renderer.setProperty(link, 'href', css_url);
		this._renderer.setProperty(link, 'rel', 'stylesheet');
		this._renderer.setProperty(link, 'type', 'text/css');

		// Create and set up the script element
		let script = this._renderer.createElement('script');
		this._renderer.setProperty(script, 'src', script_url);
		this._renderer.setProperty(script, 'type', 'text/javascript');

		// Create and set up the data div
		let dataDiv = this._renderer.createElement('div');
		/** *set fundraiser related attributes */
		this._renderer.setProperty(dataDiv, 'id', `share-widget-${data.div_id}`);
		this._renderer.addClass(dataDiv, data.div_class);
		this._renderer.setAttribute(dataDiv, 'data-slug', data.data_slug);
		this._renderer.setAttribute(dataDiv, 'data-lang', data.data_lang);
		this._renderer.setAttribute(
			dataDiv,
			'data-box-shadow',
			data.data_box_shadow
		);
		this._renderer.setAttribute(
			dataDiv,
			'data-primary-color',
			data.data_primary_color
		);
		this._renderer.setAttribute(
			dataDiv,
			'data-secondary-color',
			data.data_secondary_color
		);
		this._renderer.setAttribute(
			dataDiv,
			'data-font-family',
			data.data_font_family
		);
		this._renderer.setAttribute(
			dataDiv,
			'data-button-radius',
			data.data_button_radius
		);
		this._renderer.setAttribute(dataDiv, 'data-card', data.data_card);
		this._renderer.setAttribute(dataDiv, 'data-form_mode', data.div_value);

		// Append elements in the correct order
		this._renderer.appendChild(wrapperDiv, link);
		this._renderer.appendChild(wrapperDiv, dataDiv);
		this._renderer.appendChild(wrapperDiv, script);
		this._renderer.appendChild(div, wrapperDiv);

		return div.innerHTML;
	}

	/** *Copy Embed HTML */
	copyEmbedHTML() {
		return this.embedHTML;
	}
	/* INFO: set Image Base URL */
	checkVideoUrl(url: any): SafeHtml {
		const vimeoId = this.getVideoIdFromLink(
			url,
			/^https?:\/\/(?:www\.)?vimeo\.com\/(\d+)/
		);
		const youtubeId = this.getVideoIdFromLink(
			url,
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/
		);

		if (vimeoId) {
			return `https://vumbnail.com/${vimeoId}.jpg`;
		} else if (youtubeId) {
			return `https://i.ytimg.com/vi/${youtubeId}/mqdefault.jpg`;
		} else {
			return 'unknown';
		}
	}

	getVideoIdFromLink(url: string, pattern: RegExp): string {
		const match = url?.match(pattern);
		return match && match[1] ? match[1] : '';
	}

	updatePrimaryColorFromInput(event: Event) {
		const colorValue = (event.target as HTMLInputElement).value;
		this.pluginForm.get('currentPrimaryColor')?.setValue(colorValue);
	}

	updateSecondaryColorFromInput(event: Event) {
		const colorValue = (event.target as HTMLInputElement).value;
		this.pluginForm.get('currentSecondaryColor')?.setValue(colorValue);
	}

	updatePrimaryColorFromColorPicker(event: Event) {
		const colorInput = event.target as HTMLInputElement;
		const colorValue = colorInput.value;
		this.pluginForm.get('currentPrimaryColor')?.setValue(colorValue);
	}

	updateSecondaryColorFromColorPicker(event: Event) {
		const colorInput = event.target as HTMLInputElement;
		const colorValue = colorInput.value;
		this.pluginForm.get('currentSecondaryColor')?.setValue(colorValue);
	}

	changeFontFamily() {
		const fontFamily = this.pluginForm.get('widgetFontName')?.value;
	}

	onchangeButtonRadius() {
		const radius = this.pluginForm.get('currentButtonRadius')?.value;
	}

	updateBoxShadow() {
		const boxShadowNumber = this.pluginForm.get('boxShadowNumber')?.value;
		this.previewBoxShadowNumber = boxShadowNumber;
		this.updateEmbedPreview();
	}

	updateEmbedPreview() {
		const newBoxShadow = this.pluginForm.get('boxShadowNumber')?.value;
		const primaryColor = this.pluginForm.get('currentPrimaryColor')?.value;
		const secondaryColor = this.pluginForm.get('currentSecondaryColor')?.value;
		const fontFamily = this.pluginForm.get('widgetFontName')?.value;
		const buttonRadius = this.pluginForm.get('currentButtonRadius')?.value;

		this._mediaService.updateEmbedPreview(
			newBoxShadow,
			primaryColor,
			secondaryColor,
			fontFamily,
			buttonRadius
		);
	}
}
